import styled, { css } from 'styled-components';
import { Box, ToggleSwitch, LabelBold } from '@comeon/ui';

const SwitchLabel = styled(LabelBold)`
	${({ isActive }) =>
		!isActive &&
		css`
			color: var(--we-spin-dashboard-switch-label-disabled);
		`}
`;

const WeSpinToggleSwitch = ({ label, onSwitch, isActive, isDisabled, onClick }) => (
	<Box justifyContent="space-between" alignItems="center" display="flex" flexGrow={1} onClick={onClick}>
		<SwitchLabel isActive={isActive}>{label}</SwitchLabel>
		<ToggleSwitch
			isActive={isActive}
			onClick={onSwitch}
			readonly
			customToggleOnKnobBg="var(--we-spin-dashboard-switch-toggle-on-knob-bg)"
			customToggleOnBg="var(--we-spin-dashboard-switch-toggle-on-bg)"
			customToggleDisabledBg="var(--we-spin-dashboard-switch-toggle-disabled-bg)"
			customToggleDisabledKnobBg="var(--we-spin-dashboard-switch-toggle-disabled-knob-bg)"
			customToggleOffBg="var(--we-spin-dashboard-switch-toggle-off-bg)"
			customToggleOffKnobBg="var(--we-spin-dashboard-switch-toggle-off-knob-bg)"
			isDisabled={isDisabled}
		/>
	</Box>
);

export default WeSpinToggleSwitch;
